import { createRouter, createWebHistory } from 'vue-router'



const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: ()=> import("../views/HomeView.vue")
    },
    {
      path: '/sound',
      name: 'sound',
      component: ()=> import("../views/Sound.vue")
    },
    {
      path: '/widget',
      name: 'widget',
      component: ()=> import("../views/SoundWidget.vue")
    }
  ]
})

export default router
